import type { RefObject } from 'react'

import { useEffect, useRef, useState } from 'react'

export const useElementWidth = <T extends HTMLElement>(fallback: number): [RefObject<T | null>, number] => {
    const ref = useRef<T>(null)
    const [width, setWidth] = useState(fallback)

    useEffect(() => {
        const element = ref.current
        if (!element) return

        const update = () => {
            const next = Math.max(120, Math.round(element.getBoundingClientRect().width))
            setWidth(previous => (previous === next ? previous : next))
        }

        update()

        if (typeof ResizeObserver === 'undefined') return

        const observer = new ResizeObserver(() => update())
        observer.observe(element)

        return () => observer.disconnect()
    }, [])

    return [ref, width]
}
